
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { SundayMarketPriceFilters } from '@/types/database/sunday-market-prices';

interface SundayMarketPricesFilterProps {
  filters: SundayMarketPriceFilters;
  onFiltersChange: (filters: SundayMarketPriceFilters) => void;
  onClearFilters: () => void;
}

const SundayMarketPricesFilter: React.FC<SundayMarketPricesFilterProps> = ({
  filters,
  onFiltersChange,
  onClearFilters,
}) => {
  const handleFilterChange = (key: keyof SundayMarketPriceFilters, value: string) => {
    onFiltersChange({
      ...filters,
      [key]: value || undefined,
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value);

  return (
    <div className="bg-white p-4 rounded-lg border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Filters</h3>
        {hasActiveFilters && (
          <Button variant="outline" size="sm" onClick={onClearFilters}>
            Clear Filters
          </Button>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <Label htmlFor="product_name_filter">Product Name</Label>
          <Input
            id="product_name_filter"
            type="text"
            placeholder="Search by product name"
            value={filters.product_name || ''}
            onChange={(e) => handleFilterChange('product_name', e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="location_filter">Location</Label>
          <Input
            id="location_filter"
            type="text"
            placeholder="Search by location"
            value={filters.location || ''}
            onChange={(e) => handleFilterChange('location', e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="date_from_filter">From Date</Label>
          <Input
            id="date_from_filter"
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => handleFilterChange('date_from', e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="date_to_filter">To Date</Label>
          <Input
            id="date_to_filter"
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => handleFilterChange('date_to', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SundayMarketPricesFilter;
